import { WhmStack, WhmTypography } from "@securitize/reactjs-whm";
import { Translate } from "../../../Translation/Translate";
import { translationKeys } from "../../../../contexts/I18nContext";
import { ReactComponent as EmptyIllustation } from "./Empty.svg";
import { AddMemberButton } from "./AddMemberButton";

export default function EmptyKeyPartiesOverlay({
  onAddIndividualClick,
  onAddEntityClick,
}: {
  onAddIndividualClick: () => void;
  onAddEntityClick: () => void;
}) {
  return function InnerEmptyKeyPartiesOverlay() {
    return (
      <WhmStack
        alignItems="center"
        sx={{
          px: { xs: "16px", xl: "100px" },
          pb: { xs: "16px", xl: "0" },
        }}
        gap="16px"
        justifyContent="center"
        height="100%"
      >
        <EmptyIllustation />
        <WhmStack alignContent="center">
          <WhmTypography variant="h4" align="center">
            <Translate
              translationKey={
                translationKeys.PROFILE_KEY_PARTIES_NO_KEY_PARTIES
              }
            />
          </WhmTypography>
          <WhmTypography align="center">
            <Translate
              translationKey={
                translationKeys.PROFILE_KEY_PARTIES_NO_KEY_PARTIES_DETAIL
              }
            />
          </WhmTypography>
        </WhmStack>
        <AddMemberButton
          onAddIndividualClick={onAddIndividualClick}
          onAddEntityClick={onAddEntityClick}
        />
      </WhmStack>
    );
  };
}
